import {ReactNode} from "react";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";
import BorderVerticalIcon from "@mui/icons-material/BorderVertical";
import BorderHorizontalIcon from "@mui/icons-material/BorderHorizontal";
import {MdFrameJoint} from "../model/frame/MdFrameBlock";

// the ways two sticks can terminate where they meet, shared by the Screen tab
// (frame-wide default) and the Selected Stick tab (per-joint override). "Notch"
// names which stick is cut short (the other runs through / owns the corner); a
// miter cuts both on the shared inner->outer corner line.
export const JOINT_OPTIONS: {type: MdFrameJoint; label: string; icon: ReactNode}[] = [
    {type: "miter", label: "Miter", icon: <ChangeHistoryIcon />},
    {type: "cap", label: "Cap", icon: <BorderVerticalIcon />},
    {type: "extend", label: "Extend", icon: <BorderHorizontalIcon />},
];
